import { api } from './base';

import { MutationArg } from 'v2/types';
import { PartnerModel } from 'v2/types/PartnerModel';
import { SWRKeyValue } from 'v2/types/swr';

export const partnersService = {
  getPartners(): Promise<PartnerModel[]> {
    return api.get('admin/partner').json();
  },

  createPartner(_key: string, { arg }: MutationArg<Omit<PartnerModel, 'id' | 'order'>>): Promise<PartnerModel> {
    return api.post('admin/partner', { json: arg }).json();
  },

  updatePartner(
    [_key, partnerId]: SWRKeyValue,
    { arg }: MutationArg<Omit<PartnerModel, 'id' | 'order'>>
  ): Promise<PartnerModel> {
    return api.put(`admin/partner/${partnerId}`, { json: arg }).json();
  },

  deletePartner([_key, partnerId]: SWRKeyValue): Promise<void> {
    return api.delete(`admin/partner/${partnerId}`).json();
  },

  changePartnersOrder(
    _key: string,
    { arg }: MutationArg<Pick<PartnerModel, 'id' | 'order'>[]>
  ): Promise<PartnerModel[]> {
    return api.patch('admin/partner/order', { json: arg }).json();
  },
};
